import { initSubRoutes } from '../../../../utils/router';

const RoutesModifierPersonnePhysique = initSubRoutes({
    route: '/modifier-personne-physique/',
    subroutes: {},
    nom: 'Modification des informations personnelles',
});

export default RoutesModifierPersonnePhysique;
